import DOMPurify from 'dompurify';
/**
 * Linkify a string of text.
 * @param {String} text. The text to linkify.
 * @return {String}
 */

export default function linkify(text) {
  // eslint-disable-next-line no-useless-escape, max-len
  const urlRegex = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
  const toLink = (url) => `<a href="${url}" target="_blank">${url}</a>`;
  const newText = text.replace(urlRegex, toLink);
  // eslint-disable-next-line max-len
  return DOMPurify.sanitize(newText, { ALLOWED_TAGS: ['a'], ALLOWED_ATTR: ['href', 'target'] });
}
